import React from 'react';
import { Form } from 'react-bootstrap';
import { StatsFilters as StatsFiltersType, TIME_PERIOD_OPTIONS, TimePeriod } from '../../../../../domain/statsFilters';

type TimePeriodSelectorProps = {
    timePeriod: TimePeriod;
    onChange: (period: TimePeriod, defaultTimePeriodRelatedFilterValue: Partial<StatsFiltersType>) => void;
}

export const TimePeriodSelector = ({ timePeriod, onChange }: TimePeriodSelectorProps) => (
    <>
        {Object.entries(TIME_PERIOD_OPTIONS).map(([timePeriodSelector, { label, defaultStats }]) => (
            <Form.Check
                key={timePeriodSelector}
                className="me-2"
                inline
                type="radio"
                id={`period-${timePeriodSelector}`}
                label={label}
                name="period"
                value={timePeriodSelector}
                checked={timePeriod === timePeriodSelector}
                onChange={(e) => onChange(e.target.value as TimePeriod, defaultStats)}
            />
        ))}
    </>
);